(ns frontend.components.inputs.select
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.field :as field]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.registry :as registry]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.components.open-search-select :as open-search-select]
   [frontend.logging :as logging]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.view.components.select :as select-comp]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.select-asset-type.view :as select-asset-type]
   [reagent.core :as r]
   [reagent.impl.component :as reagent-component]))

(defn keywordize
  [str-value]
  (let [res (if (= \: (first str-value))
              (keyword (subs str-value 1))
              (keyword str-value))]
    res))

(defn create-new-entity
  [{:keys [input-text entity-type creation-pipeline-id attribute on-blur! on-change! clear-atom!
           mandatory-entity-fields]}]
  (f-entity/open-creator!
   entity-type
   {:named-value-attribute attribute
    :start-value           input-text
    :skip-success-msg?     true
    :creation-pipeline-id  creation-pipeline-id
    :mandatory-fields      mandatory-entity-fields
    :on-ok!                (fn [{:keys [new-entity-id close-cb!]}]
                             (try
                               (when on-change!
                                 (on-change! nil new-entity-id))
                               (if on-blur!
                                 (on-blur! nil new-entity-id clear-atom!)
                                 (clear-atom! nil))
                               (catch js/Object e
                                 (logging/error "Failed to create new entity : " e)))
                             (close-cb!))}))

(defn handle-new-option
  [{:keys [:new-option-text :on-blur! :clear-atom!]}]
  (on-blur! nil
            {:new-option new-option-text}
            ;; TODO: also close dropdown
            clear-atom!))

(defn coerce-select-value
  [value-type v]
  (case value-type
    :keyword (if (keyword? v)
               v
               (keywordize v))
    :string (if (string? v)
              v
              (str v))
    :number (if (number? v)
              v
              (when (re-matches #"\d+.?\d*" (str v)) (js/parseInt (str v))))
    :entity v
    (str v)))

(defn render-select
  [dom-atom args]
  (let [{:keys [is-multi
                tenant-schema
                value
                attribute
                containing-entity-type
                containing-entity
                creation-pipeline-id
                value-type
                field/entity-types
                field/not-clearable?
                placeholder
                read-only? options
                on-blur! on-change!
                disabled?
                mandatory-entity-fields
                custom-target-asset-create?
                custom-target-asset-new-handler
                custom-target-asset-existing-handler]} args
        entity-types (or entity-types
                         (:entity/type args))
        create-entity-types (field/create-entity-types args)
        creatable-entity-types (when create-entity-types
                                 (->> create-entity-types
                                      (remove (fn [et]
                                                ;;TODO should be updated to use a list of allowed entity-types.
                                                ;; likely solution: (-> common.schema.entity-types/entities :creatable-entity-types)
                                                ;; -note: it's missing at least named-value => won't use yet in case something else
                                                ;;        important is missing
                                                (some #{et}
                                                      [:entity.type/account
                                                       :entity.type/fund
                                                       :entity.type/team
                                                       :entity.type/webentry
                                                       ;; no longer explicit creation:
                                                       :entity.type/investor
                                                       :entity.type/kpi-category
                                                       :entity.type/pipeline])))))
        named-value-attribute (:named-value-attribute args)
        ;;_ (js/console.log "Select val : " value " << " @dom-atom)
        edit-value (or (:temp-select-value @dom-atom)
                       value)
        clear-atom! (fn [_]
                      (swap! dom-atom dissoc :temp-select-value)
                      ;; force sync
                      (deref dom-atom))
        on-change-select! (if custom-target-asset-create?
                            ;; Use the entity creation side panel in the existing Entity Custom Display or Edit
                            custom-target-asset-existing-handler
                            ;; Else use the prior entity modal creation
                            (fn [selected-value]
                              (let [new-value (if is-multi
                                                (->> selected-value
                                                     (map (partial coerce-select-value value-type))
                                                     (remove nil?)
                                                     (set))
                                                (coerce-select-value value-type selected-value))]

                                (swap! dom-atom assoc :temp-select-value new-value)
                                (deref dom-atom)                                                    ;; force sync

                                (when on-change!
                                  (on-change! nil new-value))
                                (when on-blur!
                                  (on-blur! nil new-value clear-atom!)))))
        create-new-entity!
        (if custom-target-asset-create?
          ;; Use the entity creation side panel in the new Entity Custom Creation
          custom-target-asset-new-handler
          ;; Else use the prior entity modal creation
          (fn [selected-entity-type input-text]
            (create-new-entity
             {:entity-type             selected-entity-type
              :attribute               named-value-attribute                                        ;;needed for named-values
              :creation-pipeline-id    creation-pipeline-id
              :input-text              input-text
              :on-blur!                (fn [e val clear-atom!]
                                         (let [refreshed-edit-value (or (:temp-select-value @dom-atom)
                                                                        value)
                                               new-val (if is-multi
                                                         (conj (or refreshed-edit-value #{}) val)
                                                         val)]
                                           (swap! dom-atom assoc
                                                  :cache-version
                                                  (inc (or (:cache-version @dom-atom)
                                                           0)))
                                           (deref dom-atom)                                         ;; force sync
                                           (when on-blur!
                                             (on-blur! e new-val clear-atom!))))
              :on-change!              (fn [e val]
                                         (let [refreshed-edit-value (or (:temp-select-value @dom-atom)
                                                                        value)
                                               new-val (if is-multi
                                                         (conj (or refreshed-edit-value #{}) val)
                                                         val)]
                                           (swap! dom-atom assoc :temp-select-value new-val)
                                           (deref dom-atom)                                         ;; force sync
                                           (when on-change!
                                             (on-change! e new-val))))
              :mandatory-entity-fields mandatory-entity-fields
              :clear-atom!             clear-atom!})))
        on-create-option!
        (fn [option-text]
          (if (= value-type :entity)
            (if (= (count creatable-entity-types) 1)
              (create-new-entity! (first creatable-entity-types) option-text)
              (modals/open-modal!
               select-asset-type/modal-key
               {:allowed-asset-types creatable-entity-types
                :modal-title         (or (->> attribute
                                              (registry/get-field-schema tenant-schema)
                                              :field/select-target-title
                                              :en)
                                         (loc/tr :select-type))
                :select-label        (or (->> attribute
                                              (registry/get-field-schema tenant-schema)
                                              :field/select-target-label
                                              :en)
                                         (loc/tr :type))
                :on-select!          (fn [selected-type close-modal!]
                                       (close-modal!)
                                       (create-new-entity! selected-type option-text))
                :on-cancel!          (fn [_])}))
            (handle-new-option
             {:args        args
              :on-blur!    (fn [e nv clear-atom!]
                             (let [refreshed-edit-value (or (:temp-select-value @dom-atom)
                                                            value)
                                   new-val (if is-multi
                                             (conj (or refreshed-edit-value #{}) nv)
                                             nv)]
                               (swap! dom-atom assoc
                                      :cache-version
                                      (inc (or (:cache-version @dom-atom)
                                               0)))
                               (deref dom-atom)                                                     ;; force sync
                               (when on-blur!
                                 (on-blur! e new-val clear-atom!))))
              :clear-atom! clear-atom!})))
        common-props (merge {:value                  edit-value
                             :is-clearable           (not not-clearable?)
                             :cache-options          (or (:cache-version @dom-atom) true)
                             :containing-entity      containing-entity
                             :placeholder            placeholder
                             :read-only?             (or read-only? (boolean disabled?))
                             :key                    (some-> args
                                                             :key-atom
                                                             deref
                                                             str)
                             :menu-placement         (or (:menu-placement args) "auto")
                             :on-change!             on-change-select!
                             :default-options        true
                             :filter-fn              (:field/option-filter-fn args)
                             :options                options
                             :entity-types           entity-types
                             :creatable-entity-types creatable-entity-types
                             :value-type             value-type
                             :named-value-attribute  named-value-attribute
                             :attribute              attribute
                             :entities-atom          session/entities}
                            (select-keys args
                                         [:is-multi
                                          :field/data-type
                                          :prompt-text-creator-keyword
                                          :field/custom-sort
                                          :max-opts-visible
                                          :force-opts-height?
                                          :menu-portal-target
                                          :close-menu-on-scroll?
                                          :debug?
                                          :refreshToken
                                          :filter-fn
                                          :entity-types-atom
                                          :menu-placement
                                          :match-any-word?]))]
    (if
     (and
      (:create-on-fly? args)
      (let [system-level-creatable? (some #{attribute}
                                          [:oppo/target-asset
                                           :investor/legal-entity
                                           :sale-agreement/customer
                                           :survey-profile/target
                                           :tenant/lp-portal-news-categories
                                           :tenant/lp-portal-news-types])
            single-creatable? (and creatable-entity-types
                                   (= (count creatable-entity-types) 1))
            module-access? (case (first creatable-entity-types)
                             :entity.type/company true
                             :entity.type/real-estate true
                             :entity.type/fof-asset true
                             :entity.type/other-asset true
                             :entity.type/person true
                             :entity.type/investor true
                             :entity.type/oppo (session/dealflow?)
                             :entity.type/fundraising-opportunity (session/fundraising?)
                             :entity.type/holding (session/portfolio?)
                             :entity.type/any true
                             false)
            pipeline-id (pipeline/entity-pipeline containing-entity)
            config-access? (f-permissions/field-option-create-access?
                            attribute
                            containing-entity-type
                            pipeline-id)
            can-create? (or system-level-creatable?
                            (and single-creatable?
                                 module-access?)
                            config-access?)]
        can-create?))
      [select-comp/select-creatable
       (merge common-props
              {:placeholder      (or placeholder (loc/tr :add-new-or-select))
               :on-create-option on-create-option!})]
      [select-comp/select common-props])))

(defn force-remount?
  [prev-props new-props]
  (let [;;remounting if these props change - update list as needed:
        remount-prop-keys [:value :options :field/entity-types :field/select-entity-types :field/create-entity-types :entity/type :field/attribute]
        prev-remount-values (-> prev-props
                                (select-keys remount-prop-keys))
        new-remount-values (-> new-props
                               (select-keys remount-prop-keys))]
    (not= prev-remount-values new-remount-values)))


(defn field-select
  [args]
  (let [dom-atom (r/atom nil)
        key-atom (r/atom (str (gensym "select-component")))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]
    ;; ref vs atom
    (r/create-class
     {:display-name           "Select"
      :component-did-mount    (fn [_mount-args]
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    (when-let [dom-node (:input-dom-node @dom-atom)]
                                                      (.focus dom-node)))))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc
                                                             :temp-select-value))))
                                ;; save complete -> reset temp state
                                (when set-save!
                                  (set-save! (fn [_]
                                               (when-let [dom-node (:input-dom-node @dom-atom)]
                                                 (.blur dom-node))))))
      :component-did-update   (fn [this old-argv]
                                (let [prev-props (reagent-component/extract-props old-argv)
                                      new-props (r/props this)]
                                  (when (force-remount? prev-props new-props)
                                    ;;force remount
                                    (reset! key-atom (str (gensym "select-component"))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (let [use-ref-selector? (some #{(:field/data-type args)}
                                                              [:data.type/ref-multi :data.type/ref-single])]
                                  (if use-ref-selector?
                                    (open-search-select/render-async-select-single args)
                                    (render-select dom-atom (assoc args :key-atom key-atom)))))})))

(defmethod editor :editor.type/select
  [args]
  [field-select args])

(defmethod display-string :editor.type/select
  [args]
  (let [value (:value args)
        ;; Entity pages pass a ref-single value as the pulled entity map rather
        ;; than its id - normalize so both shapes resolve to a label.
        selected-entity (when (and (map? value) (:db/id value)) value)
        selected-id (if selected-entity (:db/id selected-entity) value)
        options (:options args)]
    (when selected-id
      (or (some->> options
                   (filter (fn [o]
                             (or (= (:key o) selected-id)
                                 (= (:keyword o) selected-id))))
                   (first)
                   (:label))
          ;; ref-single fields resolve their options asynchronously (OpenSearch),
          ;; so `:options` never reaches here - resolve the entity label directly.
          (when (number? selected-id)
            (entity/display-string (or (session/get-entity selected-id)
                                       selected-entity)
                                   :long
                                   session/get-entity))))))

(defmethod viewer :editor.type/select
  [_args]
  (r/create-class
   {:display-name "select/viewer"
    :reagent-render
    (fn [args]
      (let [selected (:value args)
            component-id (:id args)
            attribute (:attribute args)
            options (:options args)]
        [:div.preview.preview-select
         (when selected
           (let [label (or (some->> options
                                    (filter (fn [o]
                                              (or (= (:key o) selected)
                                                  (= (:keyword o) selected))))
                                    (first)
                                    :label)
                           (when (number? selected)
                             (->> (get @session/entities selected)
                                  (entity/display-string))))
                 clickable? (and (number? selected)
                                 (let [entity-type (:entity/type (get @session/entities selected))]
                                   (some #{entity-type} routing/clickable-entity-types)))]
             (if clickable?
               [:span
                {:key      (str component-id "-comp-" attribute "-" selected)
                 :href     "#"
                 :on-click (fn [e]
                             (routing/open-entity selected)
                             (.preventDefault e))}
                label]
               [:span {:key (str component-id "-comp-" attribute "-" selected)}
                label])))]))}))
